import React from 'react'
import PropTypes from 'prop-types'

class CheckVariants extends React.Component {
    render() {
        const {product} = this.props
        const {size, color} = product

        return (
            <div className='CheckVariants mr-3'>
                <h3 className="ColorVariant">
                    <span>Color: {color}</span>
                    <div className='DemoColor' style={{backgroundColor: color}}/>
                </h3>
                <h3>Size: {size}</h3>
            </div>
        )
    }
}

CheckVariants.propTypes = {
    product: PropTypes.object.isRequired
}

export default CheckVariants
